export default __webpack_public_path__ + "static/media/wind-5.7adc5df1.png";